// extracted by mini-css-extract-plugin
export default {"item_type_separator":"AYEEK","item_type_page":"gGuYa","item_active":"rRsmC"};